<template>
  <div class="job-detail">
    <div class="title-wrapper">
      <div class="position">{{ position }}</div>
      <div class="cnPosition">/ {{ subtitle }}</div>
    </div>
    <div class="content-wrapper">
      <div class="intro-wrapper">
        <div :class="{ intro: intro }" v-html="intro"></div>
        <div class="needs" v-html="needs"></div>
      </div>
      <div class="welfare">
        <div>實習生福利：</div>
        <ul>
          <li>時薪：$190，之後視實際能力與貢獻增加</li>
          <li>彈性工作時間、實習周數與每週上班天數</li>
          <li>免費零食飲料咖啡氣泡水</li>
          <li>電影之夜，每季一次</li>
          <li>不定期舉辦 Workshop，課程內容開放大家提議</li>
          <li>社團活動與不定期 Teambuilding 活動</li>
          <li>運動 / 健身補助</li>
          <li>充分享受在 Spotify 音樂與垃圾話穿插夾雜的團隊樂趣</li>
          <li>接觸各領域的領導品牌客戶，參與超過上萬人使用的產品專案</li>
          <li>實習期間表現優異，我們將誠摯地歡迎您成為我們的正職夥伴</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jobDetail",
  props: ["position", "subtitle", "intro", "needs", "cnPosition"],
};
</script>

<style scoped
       lang="scss">
@import "../../static/styles/palette.scss";

.job-detail {
  display: block;
  color: white;
  width: 960px;
  letter-spacing: 0.8px;

  & .title-wrapper {
    display: block;
    margin-bottom: 60px;

    & .position {
      font-family: "Fugaz One";
      font-size: 40px;
      letter-spacing: 2px;
      margin-bottom: 20px;
    }
    & .cnPosition {
      font-weight: bold;
      font-size: 16px;
      letter-spacing: 1.5px;
    }
  }

  & .content-wrapper {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 25px;
    letter-spacing: 1px;

    & .intro-wrapper {
      width: 46%;

      & .subtitle {
        margin-bottom: 20px;
      }

      & .intro {
        margin-bottom: 40px;
      }
    }

    & .welfare {
      width: 46%;
      color: $gray;
      font-weight: bold;

      & ul {
        padding-left: 15px;
        margin-top: 0;
        font-weight: normal;
      }
    }
  }
}

@media all and (max-width: 1200px) {
  .job-detail {
    width: 85%;

    & .content-wrapper {
      & .intro-wrapper {
        width: 48%;
        margin-bottom: 50px;
      }

      & .welfare {
        width: 48%;
      }
    }
  }
}

@media all and (max-width: 960px) {
  .job-detail {
    width: 85%;

    & .content-wrapper {
      flex-direction: column;

      & .intro-wrapper {
        width: 100%;
        margin-bottom: 50px;
      }

      & .welfare {
        width: 100%;
      }
    }
  }
}

@media all and (max-width: 480px) {
  .job-detail {
    & .title-wrapper {
      & .position {
        font-size: 34px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// JobDetail.vue?0a95e7cf